export const setLSLanguage = (lang: string): void => {
    localStorage.setItem('language', lang);
}

export const getLSLanguage = (): string | null => {
    return localStorage.getItem('language');
};

export const PHONE_NUMBER_KEY = 'ertk7';

export const setSSPhoneNumber = (phoneNumber: string): void => {
    sessionStorage.setItem(PHONE_NUMBER_KEY, phoneNumber);
}

export const getSSPhoneNumber = (): string | null => {
    return sessionStorage.getItem(PHONE_NUMBER_KEY);
};

export const setSSCodesSent = (tries: string): void => {
    sessionStorage.setItem('tries', tries);
}

export const getSSCodesSent = (): number => {
    return Number(sessionStorage.getItem('tries'))
};